import type { LocalConfigurations, RemoteConfigurations } from '~/server/types/configuration'

export const stores = () => {
  const RemoteConfigurationStore = useState<RemoteConfigurations | null | undefined>(
    'RemoteConfiguration'
  )
  const LocalConfigurationStore = useState<LocalConfigurations | null | undefined>(
    'LocalContentConfiguration'
  )

  const GeolocationStore = useState<object | null | undefined>('Geolocation', () => null)

  const Debug = useState<boolean | null | undefined>('Debug', () => false)

  return {
    RemoteConfigurationStore,
    LocalConfigurationStore,
    GeolocationStore,
    Debug,
  }
}
